import { TClearButtonPosition } from 'core-components/library/filter'
import { IProperties } from 'core-components/sitebuilder/propertygenerator'

interface IInitializeDataActions {
  rerender?: () => void
}

export interface IInitializeData {
  actions?: IInitializeDataActions
}

export const getAccordionFilterProperties = (): IProperties[] => {
  return [
    {
      name: 'source',
      type: 'string',
      needLoad: true,
      required: true,
      value: '',
    },
    {
      name: 'editorSources',
      type: 'string',
      needLoad: true,
      required: true,
      value: '',
    },
    {
      name: 'dataFields',
      type: 'string',
      needLoad: true,
      required: true,
      value: '',
    },
    {
      name: 'clearButtonVisible',
      type: 'enum',
      enumValues: [
        { key: TClearButtonPosition.Main, value: TClearButtonPosition.Main },
        { key: TClearButtonPosition.Full, value: TClearButtonPosition.Full },
        { key: TClearButtonPosition.FilterRow, value: TClearButtonPosition.FilterRow },
      ],
      value: '',
    },
    {
      name: 'collapseGroupOnChange',
      type: 'boolean',
      value: false,
    },
  ]
}
